import { StainType } from 'interfaces/stainType';
import { apiRequestHandlerPromise } from 'utils/apiRequestHandler';
import { CasesParams } from 'utils/useCasesParams/types';

type StainTypeFilteredIdsParams = CasesParams & {
  pendingSlidesMode?: boolean;
};

export const getStainTypeOptions = (signal?: AbortSignal) => {
  return apiRequestHandlerPromise<StainType[]>({
    url: `stain_types.get`,
    method: 'GET',
    signal,
  });
};

export const getStainTypeFilteredIds = (caseParams: StainTypeFilteredIdsParams, signal?: AbortSignal) => {
  return apiRequestHandlerPromise<string[]>({
    url: `stain_types/filtered_ids.get`,
    method: 'POST',
    signal,
    data: JSON.stringify(caseParams),
  });
};

// the index is not used in the request, we take it out to not send it
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const createStainTypeOption = ({ index, ...data }: StainType) => {
  return apiRequestHandlerPromise<StainType>({
    url: 'stain_types.create',
    method: 'POST',
    data: JSON.stringify(data),
  });
};

// the index is not used in the request, we take it out to not send it
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const updateStainTypeOption = ({ id, index, ...data }: StainType) => {
  return apiRequestHandlerPromise({
    url: `stain_types.update/${id}`,
    method: 'POST',
    data: JSON.stringify(data),
  });
};

export const deleteStainTypeOption = (id: string) => {
  return apiRequestHandlerPromise({
    url: `stain_types.delete/${id}`,
    method: 'DELETE',
  });
};
